"use strict";

(function () {
  const STORAGE_KEY = "glozin__wishlist-items";
  const wishlistDiv = document.querySelector(".wishlist-page-main");

  function getWishlistItems() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(items) ? items : [];
    } catch (error) {
      console.error("Unable to read wishlist storage:", error);
      return [];
    }
  }

  function showEmptyState() {
    if (!wishlistDiv) return;
    const emptyState = wishlistDiv.querySelector(".wishlist-no-product-js");
    if (emptyState) emptyState.classList.remove("hidden");
    const list = wishlistDiv.querySelector(".wishlist-list-items");
    if (list) list.remove();
  }

  function hideSkeleton() {
    const skeleton = document.querySelector("skeleton-page");
    if (skeleton) skeleton.remove();
    const inner = document.querySelector(".wishlist-page-section-inner");
    if (inner) inner.classList.remove("hidden");
  }

  function removeWishlistItem(productId) {
    const updatedItems = getWishlistItems().filter(
      (id) => String(id) !== String(productId)
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedItems));
    // Rebuild the list from the updated storage; reload also refreshes theme state.
    window.location.reload();
  }

  function initWishlistItems() {
    if (!wishlistDiv) return;
    if (new URLSearchParams(window.location.search).has("page")) return;

    const items = getWishlistItems();
    if (items.length === 0) {
      showEmptyState();
      hideSkeleton();
      return;
    }

    const section = document.querySelector(".wishlist-page-section");
    if (!section || !section.dataset.sectionId || !window.routes || !window.routes.search_url) {
      console.error("Wishlist section or Shopify search route was not found.");
      hideSkeleton();
      return;
    }

    const query = items.map((id) => `id:${encodeURIComponent(id)}`).join("%20OR%20");
    const url = `${window.routes.search_url}?section_id=${encodeURIComponent(section.dataset.sectionId)}&type=product&options[unavailable_products]=last&q=${query}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Wishlist request failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, "text/html");
        const returnedMain = doc.querySelector(".wishlist-page-main");
        const returnedList = doc.querySelector(".wishlist-page-main .wishlist-list-items");
        if (returnedMain) {
          wishlistDiv.innerHTML = returnedMain.innerHTML;
        }

        if (!returnedList || getWishlistItems().length === 0) {
          showEmptyState();
        }

        // Keep the close/remove control visible on each wishlist card.
        wishlistDiv.querySelectorAll('button-wishlist[data-action="remove"]').forEach((button) => {
          button.style.setProperty("display", "flex", "important");
          button.style.setProperty("visibility", "visible", "important");
          button.style.setProperty("opacity", "1", "important");
          button.style.setProperty("pointer-events", "auto", "important");
          button.style.setProperty("z-index", "20", "important");
          button.setAttribute("aria-label", "Remove from wishlist");
          button.setAttribute("title", "Remove from wishlist");
        });
      })
      .catch((error) => console.error("Wishlist loading error:", error))
      .finally(() => {
        hideSkeleton();
        if (typeof window.initLazyloadItem === "function") window.initLazyloadItem();
      });
  }

  // Capture the click before the theme's generic wishlist handler can redirect or toggle it.
  document.addEventListener("click", function (event) {
    const button = event.target.closest(
      ".wishlist-page-main button-wishlist[data-action='remove']"
    );
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productId = button.dataset.productId;
    if (!productId) {
      console.error("Wishlist remove button is missing data-product-id.");
      return;
    }
    removeWishlistItem(productId);
  }, true);

  // Preserve the global object name in case other theme code refers to it.
  window.WishlistPageShopify = {
    initWishlistItems,
    init: initWishlistItems,
    removeItem: removeWishlistItem,
    mergeItems: function () {
      // Intentionally do not rebuild storage from product-card buttons.
      // The wishlist page's buttons are remove controls, not add/toggle controls.
    },
    skeletonFunction: function (timer) {
      window.setTimeout(hideSkeleton, timer || 0);
    }
  };

  initWishlistItems();
})();
